import { ExcelColumn } from "api/generated/lumen";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

interface UseInventoryListColumnTitles {
  columns: ExcelColumn[];
}

const useInventoryListColumnTitles = (): UseInventoryListColumnTitles => {
  const { t } = useTranslation();

  const columns = useMemo(
    () => [
      {
        displayName: t("inventory.partNumber"),
        propertyName: "partNumber",
      },
      {
        displayName: t("inventory.name"),
        propertyName: "name",
      },
      {
        displayName: t("inventory.manufacturer"),
        propertyName: "manufacturer",
      },
      {
        displayName: t("inventory.type"),
        propertyName: "type",
      },
      {
        displayName: t("inventory.category"),
        propertyName: "category",
      },
    ],
    [t]
  );

  return {
    columns: columns,
  };
};

export default useInventoryListColumnTitles;
